import Api from "./Api";
import Csrf from "./Csrf";

export default {
	
	async upload(upload_array) {
		await Csrf.getCookie();
		
		return Api.post("/upload",upload_array);
	},

	async delete(delete_array) {
		await Csrf.getCookie();
		
		return Api.post("/delete-log-file",delete_array);
	}
	
};